import { DASH_LABELS, DASH_TYPE_GROUPS } from './dashConstants'

export const META_BY_LOCATION_DETAIL = {
  MSF: {
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  SPANL: {
    label: DASH_LABELS.SLEEPER_PANEL,
    partOverride: '43N Sleeper Panel Large',
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
  },
}

export const DASH_META = {
  name: 'SLLG_43N',
  type: DASH_TYPE_GROUPS.SLEEPER,
  panels: ['SPANL'],
  width: 1006,
  height: 1400,
}

export const FALLBACK_COMPONENTS_BY_DETAIL = {
  JJ: 'Switch',
  A: 'Gauge',
}

export default {
  ...DASH_META,
  ...META_BY_LOCATION_DETAIL,
  fallbacks: FALLBACK_COMPONENTS_BY_DETAIL,
  lists: {
    SPANL: {
      id: 'SPANL',
      label: DASH_LABELS.SLEEPER_PANEL,
      hideAddMsf: true,
      groups: {
        SRRSD: {
          id: 'SRRSD',
          panel: 'SPANL',
          label: 'MSF Right',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['JJ'],
        },
        SLLSD: {
          id: 'SLLSD',
          panel: 'SPANL',
          label: 'MSF Left',
          canDragGroup: true,
          isMsfOrMst: true,
          detail: ['JJ'],
        },
        gauges: {
          id: 'gauges',
          panel: 'SPANL',
          label: 'Gauges',
          canDragGroup: true,
          isMsfOrMst: false,
          detail: ['A'],
        },
        other: {
          id: 'other',
          panel: 'SPANL',
          label: 'Other',
          canDragGroup: true,
          isMsfOrMst: false,
          detail: ['P', 'R', 'L', 'K', 'M', 'W', 'C-C', 'C', 'L-L', 'KT'],
        },
      },
    },
  },
}
